var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-0 pa-0"},[_c('div',{staticClass:"text-subtitle"},[_vm._v(_vm._s(_vm.$t("projects.reporting.crud.document.title")))]),_vm._l((_vm.files),function(doc,index){return _c('EqsFileInput',_vm._b({key:index,attrs:{"value":doc},on:{"update:value":val => _vm.newFile(val, index)}},'EqsFileInput',{
            editable: true,
            deleteFile: true,
            isRequired: false
        },false))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }